import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    this.boundHandleTurboLoad = this.handleTurboLoad.bind(this)
    document.addEventListener('click', this.boundCloseOnClickOutside)
    document.addEventListener('turbo:load', this.boundHandleTurboLoad)
    document.addEventListener('turbo:render', this.boundHandleTurboLoad)
    document.addEventListener('turbo:before-render', this.boundHandleTurboLoad)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseOnClickOutside)
    document.removeEventListener('turbo:load', this.boundHandleTurboLoad)
    document.removeEventListener('turbo:render', this.boundHandleTurboLoad)
    document.removeEventListener('turbo:before-render', this.boundHandleTurboLoad)
  }

  handleTurboLoad() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add('hidden')
    }
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle('hidden')
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains('hidden')) {
      this.menuTarget.classList.add('hidden')
    }
  }
}
